export default __webpack_public_path__ + "static/media/rounded-top.9efca9fc.webp";